module.exports = __webpack_public_path__ + "static/media/skill-governess.97055f37.jpg";